import Link from "next/link";
import { useRouter } from "next/router";
import { MdEdit as Edit, MdPrint as Print } from "react-icons/md";

import FacebookShareButton from "../ShareButtons/Facebook";
import TwitterShareButton from "../ShareButtons/Twitter";
import Image from "@/components/Image";
import Seo from "@/components/seo";
import { useUser } from "@/components/contexts/user";

import styles from "./Content.module.css";
import moment from "moment";

function Content({ data, children, review }) {
  const router = useRouter();
  const user = useUser();

  return (
    <div className={`container ${styles.container}`}>
      <Seo
        title={`${data.title} | ${
          review ? "Album Reviews" : data.category.categoryTitle
        }`}
        image={data.image.url}
        description={data.preview}
      />
      {data.image.height !== data.image.width && (
        <Image
          src={data.image.url}
          width={data.image.width}
          height={data.image.height}
          alt={data.title}
          layout="responsive"
        />
      )}
      <div className={`${styles.wrapper} mt-3`}>
        <header>
          <div className="row px-xl-5">
            <div className="col align-self-center order-2">
              <h1>
                {data.title}
                {data.subtitle ? `:  + ${data.subtitle}` : ""}
              </h1>
              <p id="post-date">
                {moment(data.date).format("MMMM D, YYYY")} in{" "}
                {review ? (
                  <Link href="/reviews/" className="neutral-color">
                    Album Reviews
                  </Link>
                ) : (
                  <Link href={`/blog/${data.category.slug}/`} className="neutral-color">

                    {data.category.categoryTitle}

                  </Link>
                )}
              </p>
              <p id="post-date">
                by{" "}
                <Link href={data.authorDj.url} className="neutral-color">
                  {data.authorDj.dj}
                </Link>
              </p>
              <div>
                <FacebookShareButton className="me-1" />
                <TwitterShareButton className="me-1" />
                {user.isAuthenticated ? (
                  <>
                    <a href={review ? `${router.asPath}edit/` : data.editUrl}>
                      <button type="button" className="btn btn-default me-1">
                        <Edit />
                      </button>
                    </a>
                    {review && (
                      <a href={`${router.asPath}print/`}>
                        <button type="button" className="btn btn-default">
                          <Print />
                        </button>
                      </a>
                    )}
                  </>
                ) : null}
              </div>
            </div>
            {data.image.height === data.image.width && (
              <div className="col-12 order-1 col-lg-auto order-lg-2 col-xl-3">
                <div
                  className={`${styles.album_wrapper} mx-auto ms-xl-auto me-xl-0`}
                >
                  <Image
                    src={data.image.url}
                    width={data.image.width}
                    height={data.image.height}
                    alt={`${data.title} by ${data.artist || data.authorDj.dj}`}
                  />
                </div>
              </div>
            )}
          </div>
        </header>
        <hr />
        {children}
      </div>
    </div>
  );
}

export default Content;
